import type { SemanticColor } from '@atlaskit/lozenge/types';

// This mapping is copied from Jira FE:
// https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/issue/status-theming/src/statusCategoryToThemeMap.tsx
//
// If you are going to change this, please check the Jira FE mapping first to make sure they are in sync.
//
// It uses the statusCategoryId field from GQL to map to the corresponding Atlaskit lozenge appearance.
// The category IDs follow the Jira FE mapping, while the values use the semantic ADS appearances.

const STATUS_APPEARANCE_NEUTRAL = 'neutral';
const STATUS_APPEARANCE_SUCCESS = 'success';
const STATUS_APPEARANCE_INFORMATION = 'information';

export const statusCategoryToThemeMap: Record<string, SemanticColor> = {
	'1': STATUS_APPEARANCE_NEUTRAL,
	'2': STATUS_APPEARANCE_NEUTRAL,
	'3': STATUS_APPEARANCE_SUCCESS,
	'4': STATUS_APPEARANCE_INFORMATION,
};
